import {
    getLocalSettings as getLocalSettingsAPI,
    setLocalSettings as setLocalSettingsAPI,
} from "./api";

export function getSessionSettings () {
    return getLocalSettingsAPI();
}

export function setSessionSettings (settings = {}) {
    setLocalSettingsAPI(settings);
}
